/* unplugin-vue-components disabled */import { render } from "./steps.vue?vue&type=template&id=6c60d537&scoped=true"
import script from "./steps.vue?vue&type=script&lang=js"
export * from "./steps.vue?vue&type=script&lang=js"

import "./steps.vue?vue&type=style&index=0&id=6c60d537&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c60d537"],['__file',"src/pages/onboarding/steps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c60d537"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c60d537', __exports__)) {
    api.reload('6c60d537', __exports__)
  }
  
  module.hot.accept("./steps.vue?vue&type=template&id=6c60d537&scoped=true", () => {
    api.rerender('6c60d537', render)
  })

}


export default __exports__